export enum ApiMethodEnum {
  _None = 0,
  DailyReport = 1,
  Receipt = 2,
  ReturnReceipt = 3,
  CancelTransaction = 4,

  //for configuration start from 100
  SyncDate = 100,
  SetDate = 101,
  SetVat = 102,
  SetHeader = 103,
  Fiscalize = 104,
  SetEReceiptServer = 105,
  GetDate = 106,
  GetVat = 107,
  GetHeader = 108,
  GetEReceiptServer = 109,
  TestEReceiptServer = 110
}

export enum StatusEnum {
  _None = 0,
  New = 1,
  InProgress = 2,
  Printed = 3,
  Ready = 4,
  NotFound = 254,
  Error = 255
}